import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";


const GroupUnGroup = (props) => {
  const [showGroupAlert, setGroupAlert] = useState(false);
  const [showGroupConfirmationAlert, setGroupConfirmationAlert] = useState(false);
  const [groupAlertObj, setGroupAlertObj] = useState({ alertTitle: '', alertMsg: '' });
  const [UngroupFunctionValues, setUngroupFunctionValues] = useState({ ddlGroupValue: '', bOptionalUserGroup: '', vRefIDs: '', pickupDateTime: '' });
  const [groupConfrimationAlertObj, setGroupConfirmationAlertObj] = useState({ alertTitle: '', alertMsg: '' });

  useEffect(() => {
    if (props.GridRowData === null || props.GridRowData.length <= 0) {
      setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'No request selected to perform Action.' });
      setGroupAlert(true);
    }
    else {
      const selectedGridData = props.GridRowData
      const bOptionalUserGroup = props.isChecked;
      let ddlGroupValue = (props.setSelectedGroup  && props.setSelectedGroup != -1) ? props.setSelectedGroup : "";
      const pickupDateTime = selectedGridData[0].PickupDateTime;

      const distinctManifest = [...new Set(selectedGridData
        .map(data => data.vManifestNumber)
        .filter(vManifestNumber => vManifestNumber)
      )];
      const distinctGroup = [...new Set(selectedGridData
        .map(data => data.Group)
        .filter(Group => Group)
      )];

      const allGroups = selectedGridData.map(data => data.Group);
      const selectedGroups = selectedGridData.map(data => data.Group).filter(Group => Group);

      const distinctRefIds = [...new Set(selectedGridData
        .map(data => data.ConfirmationNo)
        .filter(ConfirmationNo => ConfirmationNo)
      )];

      const vRefIDs = distinctRefIds.join(', ');

      if (props.showGroupActionCreate) { //Create new Group
        if (distinctManifest.length > 0 && distinctGroup.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Already Grouped/Clustered Trips.' });
          setGroupAlert(true);
          return;
        }
        else if (distinctManifest.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Clustered Trips.' });
          setGroupAlert(true);
          return;
        }
        else if (distinctGroup.length > 0) {
          setGroupAlertObj({ ...groupConfrimationAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Already Grouped.' });
          setGroupAlert(true);
          return;
        }

        else {
          try {
            PerformGrouping(true, true, ddlGroupValue, bOptionalUserGroup, vRefIDs, pickupDateTime);
          } catch {
            setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action Failed.' });
            setGroupAlert(true);
            return;
          }
        }
      }
      else if (props.showGroupActionUpdate) { //Update or Add to Existing
        if (distinctManifest.length > 0 && distinctGroup.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Already Grouped/Clustered Trips.' });
          setGroupAlert(true);
          return;
        }
        else if (distinctManifest.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Clustered Trips.' });
          setGroupAlert(true);
          return;
        }
        else if (distinctGroup.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Already Grouped.' });
          setGroupAlert(true);
          return;
        }
        else {
          try {
            PerformGrouping(true, false, ddlGroupValue, bOptionalUserGroup, vRefIDs, pickupDateTime);
          } catch {
            setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action Failed.' });
            setGroupAlert(true);
            return;
          }
        }
      }
      else if (props.showGroupActionUngroup) { // Ungroup
        setUngroupFunctionValues({ ...UngroupFunctionValues, ddlGroupValue, bOptionalUserGroup, vRefIDs, pickupDateTime })
        if (distinctManifest.length > 0) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Action not Allowed for Clustered Trips.' });
          setGroupAlert(true);
          return;
        }
        else if (distinctGroup.length > 0) {
          if (distinctGroup.length == selectedGridData.length && selectedGridData > 1) {
            setGroupConfirmationAlertObj({ ...groupConfrimationAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Trips Belong to Different Groups Do You want to Ungroup Selected Trips?' });
            setGroupConfirmationAlert(true);
          }
          else {
            try {
              PerformGrouping(false, false, ddlGroupValue, bOptionalUserGroup, vRefIDs, pickupDateTime);
            } catch {
              setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Selected Trips are successfully Ungrouped' });
              setGroupAlert(true);
              return;
            }
          }
        }
        else if (selectedGridData.length == allGroups.length) {
          setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/Ungroup Action', alertMsg: 'Selected Trips are not Grouped' });
          setGroupAlert(true);
          return;
        }
      }
    }
  }, []);

  const handleConfirmationAction = () => {
    try {
      PerformGrouping(false, false, UngroupFunctionValues.ddlGroupValue, UngroupFunctionValues.bOptionalUserGroup, UngroupFunctionValues.vRefIDs, UngroupFunctionValues.pickupDateTime);
    } catch {
      setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Group/UnGroup Action', alertMsg: 'Selected Trips are successfully Ungrouped' });
      setGroupAlert(true);
      return;
    }
  }

  const PerformGrouping = async (bGroup, bNewGroup, ddlGroupValue, bOptionalUserGroup, vRefIDs, pickupDateTime) => {
    let Param = {
      "bGroup": bGroup,
      "bNewGroup": bNewGroup,
      "vGroupName": ddlGroupValue,
      "bOptionalUserGroup": bOptionalUserGroup,
      "vRefIDs": vRefIDs,
      "pickupDateTime": pickupDateTime
    }
    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Grouping/MakeNewGroup", "post", { "Content-Type": "application/json" }, Param, null);
    let result = response.data;
    if (result.length > 0) {

      if (result[0].vGroupName == 'ungroup') {
        setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Success!', alertMsg: "Selected Trips are successfully ungrouped" });
        setGroupAlert(true);
        props.GridRefresh();
      }
      else if (result[0].vGroupName == 'ALREADY EXISTS') {
        setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Success!', alertMsg: "Group number is Already Exists" });
        setGroupAlert(true);
        props.GridRefresh();
      }
      else if (result[0].vGroupName != '') {
        setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Success!', alertMsg: "Selected Trips are successfully tagged with group " + "[" + result[0].vGroupName + "]" });
        setGroupAlert(true);
        props.GridRefresh();
      }
      else if (result[0].vGroupName == '') {
        setGroupAlertObj({ ...groupAlertObj, alertTitle: 'Success!', alertMsg: "Selected Trips are successfully updated" });
        setGroupAlert(true);
        props.GridRefresh();
      }
    }
  }

  const handleGroupAlertClose = () => {
    setGroupAlert(false);
    UnMountGroupComponent();
  }

  const handleGroupConfirmationClose = () => {
    setGroupConfirmationAlert(false);
    setGroupAlert(false);
    UnMountGroupComponent();
  }

  const UnMountGroupComponent = () => {
    if (props.showGroupActionCreate) {
      props.setGroupActionCreate(false);
    }
    if (props.showGroupActionUpdate) {
      props.setGroupActionUpdate(false);
    }
    if (props.showGroupActionUngroup) {
      props.setGroupActionUngroup(false);
    }
  }

  return (
    <>
      {showGroupAlert && <Modal centered show={showGroupAlert} onHide={handleGroupAlertClose} animation={false} >
        <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
          <Modal.Title className='activate_dialog_title_color'>{groupAlertObj.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{groupAlertObj.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGroupAlertClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>}

      {showGroupConfirmationAlert && <Modal centered show={showGroupConfirmationAlert} onHide={handleGroupConfirmationClose} animation={false} >
        <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
          <Modal.Title className='activate_dialog_title_color'>{groupConfrimationAlertObj.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{groupConfrimationAlertObj.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleConfirmationAction}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleGroupConfirmationClose}>
            No
          </Button>
        </Modal.Footer>
      </Modal>}

    </>
  );

};

export default GroupUnGroup;